import { createTheme } from '@mui/material/styles';

import { Locale } from '@klokhuis/core/Intl/types';
import { MuiLocalesMap } from '@klokhuis/core/MUI/MuiLocalesMap';
import { DeviceType } from '@klokhuis/utilities/UserAgent/types';
import { match } from 'css-mediaquery';

import { getSSRScreenWidth } from './getSSRScreenWidth';
import { MuiThemeConfig } from './theme.mui-config';

export function makeTheme(locale: Locale, deviceType: DeviceType) {
  const ssrMatchMedia = (query: string) => ({
    matches: match(query, {
      // The estimated CSS width of the browser.
      width: getSSRScreenWidth(deviceType),
    }),
  });

  const extendedThemeConfig = {
    ...MuiThemeConfig,
    components: {
      ...MuiThemeConfig.components,
      MuiUseMediaQuery: {
        defaultProps: {
          ssrMatchMedia,
        },
      },
    },
  };

  const value = createTheme(extendedThemeConfig, MuiLocalesMap[locale]!);

  return value;
}
